import React, { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../contexts/authContext";
import { Box, Button, TextField, Typography } from "@mui/material";
import AddCustomer from "../../components/modals/addcustomer";
import Payments from "../../components/modals/payments";
import { Modal, Option, Select, selectClasses, Sheet } from "@mui/joy";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DoneIcon from "@mui/icons-material/Done";
import CallIcon from "@mui/icons-material/Call";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import NearMeIcon from "@mui/icons-material/NearMe";
import toast from "react-hot-toast";
import axiosInstance from "../../api/axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewMobCustDetails from "../../components/modals/viewMobCustDetails";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import Webcam from "react-webcam";

const PaymentList = () => {
  const { userData, setRefresh } = useContext(AuthContext);
  const [openAddCust, setOpenAddCust] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [editId, setEditId] = useState("");
  const [search, setSearch] = useState("");
  const [scheme, setScheme] = useState("all");
  const [areaFilter, setAreaFilter] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const [openConfirmLocation, setOpenConfirmLocation] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const user_Id = localStorage.getItem("userId");
  const [openViewCustomer, setOpenViewCustomer] = useState(false);
  const [openCamera, setOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [uploading, setUploading] = useState(false);
  const webcamRef = useRef(null);

  useEffect(() => {
    if (!userData?.customers) {
      setRefresh(true); // Trigger data fetch if customers are not loaded
      return;
    }

    let filtered = userData.customers.filter(
      (item) =>
        item.status === "active" &&
        item.agent._id === user_Id &&
        item.scheme.some(
          (cs) => cs.status === "active" && cs.paymentStatus === "unpaid"
        )
    );

    // Scheme filter
    if (scheme !== "all") {
      filtered = filtered.filter((item) =>
        item.scheme.some((cs) => {
          const sid =
            cs.schemeId && cs.schemeId._id
              ? cs.schemeId._id.toString()
              : cs.schemeId;
          return (
            sid === scheme &&
            cs.status === "active" &&
            cs.paymentStatus === "unpaid"
          );
        })
      );
    }

    // Area filter
    if (areaFilter !== "all") {
      filtered = filtered.filter((item) => item.area._id === areaFilter);
    }

    // Search filter
    if (search.trim()) {
      const q = search.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.name.toLowerCase().includes(q) ||
          item.mobile.toString().includes(q) ||
          item.email.toLowerCase().includes(q) ||
          item.area.areaName.toLowerCase().includes(q)
      );
    }

    setFilteredData(filtered);
  }, [search, scheme, areaFilter, userData]);

  // Opens the payment modal for a customer
  const handlePayment = (id) => {
    setCustomerId(id);
    setOpenPaymentModal(true);
  };

  const handleViewCustomer = (id) => {
    setCustomerId(id);
    setOpenViewCustomer(true);
  };
  const handleCloseViewCustomer = () => {
    setOpenViewCustomer(false);
    setCustomerId("");
  };
  const handlePhotoUpdate = (id) => {
    setCustomerId(id);
    setOpenCamera(true); // open the camera modal
  };
  const uploadCapturedPhoto = async () => {
    setUploading(true);
    try {
      const blob = await (await fetch(imageSrc)).blob();
      const file = new File([blob], "captured.jpg", { type: blob.type });

      const formData = new FormData();
      formData.append("image", file); // must match Multer field name

      const res = await axiosInstance.put(
        `/customers/photo/${customerId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.status === 200) {
        toast.success("Photo updated");
        setRefresh(true);
        setOpenCamera(false);
        setImageSrc(null);
      }
    } catch (err) {
      toast.error("Error uploading photo");
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  // When clicking the location icon, update the current location and open the confirm modal.
  const handlenewLocation = (id) => {
    setCustomerId(id);
    updateUserLocation();
    setOpenConfirmLocation(true);
  };

  const handleCloseConfirmModal = () => {
    setOpenConfirmLocation(false);
  };

  // Fetches the current geographic location of the user using the browser’s geolocation API
  const updateUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting user location:", error);
          toast.error("Unable to retrieve your location.");
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      toast.error("Geolocation is not supported by this browser.");
    }
  };

  // Confirm button handler: Sends a PUT request to update the customer location with proper error handling.
  const handleConfirmAssign = async () => {
    if (!userLocation) {
      toast.error("Kindly Enable Location");
      return;
    }
    try {
      const { lat, lng } = userLocation;
      const res = await axiosInstance.put(`/customers/location/${customerId}`, {
        lat,
        long: lng,
      });
      if (res.status === 200) {
        toast.success("Customer Location Updated");
        setOpenConfirmLocation(false);
        setCustomerId("");
        setRefresh(true);
      }
    } catch (error) {
      console.error("Error updating location:", error);
      toast.error("Error updating location");
    }
  };

  // Navigates using Google Maps if a customer already has a saved location.
  const handleNavigation = (lat, long) => {
    if (userLocation) {
      const { lat: userLat, lng: userLng } = userLocation;
      const url = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${lat},${long}&travelmode=driving`;
      window.open(url, "_blank");
    } else {
      toast.error("User location not available");
    }
  };
  useEffect(() => {
    if (!userLocation) {
      updateUserLocation();
    }
  }, []);
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Typography
          sx={{
            color: "#800001",
            textAlign: "center",
            fontWeight: "bolder",
            fontSize: "20px",
          }}
        >
          Payments ({filteredData.length})
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* <Button
            onClick={() => setOpenAddCust(true)}
            sx={{
              display: "flex",
              gap: 2,
              backgroundColor: "#800001",
              color: "white",
              padding: "10px",
            }}
          >
            <PersonAddIcon sx={{ fontSize: "24px" }} />
            <Typography
              variant="p"
              sx={{
                fontSize: "14px",
                fontFamily: "sans-serif",
                fontWeight: 500,
                display: { xs: "none", sm: "block" },
              }}
            >
              Add Customer
            </Typography>
          </Button> */}
          <Select
            placeholder="Schemes"
            indicator={<KeyboardArrowDown />}
            onChange={(e, newValue) => {
              setScheme(newValue);
            }}
            value={scheme}
            sx={{
              width: 120,
              [`& .${selectClasses.indicator}`]: {
                transition: "0.2s",
                [`&.${selectClasses.expanded}`]: {
                  transform: "rotate(-180deg)",
                },
              },
              color: "#800001",
            }}
            defaultValue={"all"}
          >
            <Option value={"all"}>All</Option>
            {userData?.schemes
              ?.filter((scheme) => scheme.status === "active")
              .map((sch) => (
                <Option key={sch._id} value={sch._id}>
                  {sch?.schemeName}
                </Option>
              ))}
          </Select>
          <Select
            placeholder="Area"
            indicator={<KeyboardArrowDown />}
            onChange={(e, newValue) => {
              setAreaFilter(newValue);
            }}
            value={areaFilter}
            sx={{
              width: 120,
              [`& .${selectClasses.indicator}`]: {
                transition: "0.2s",
                [`&.${selectClasses.expanded}`]: {
                  transform: "rotate(-180deg)",
                },
              },
              color: "#800001",
            }}
            defaultValue={"all"}
          >
            <Option value={"all"}>All</Option>
            {userData.users
              ?.filter((user) => user._id === user_Id)[0]
              ?.areas.map((area) => (
                <Option value={area._id} key={area._id}>
                  {area?.areaName || "Unknown"}
                </Option>
              ))}
          </Select>
        </Box>
        <Box>
          <TextField
            placeholder="Search"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              width: { xs: "100%", sm: "300px" },
              "& .MuiOutlinedInput-input": {
                padding: "10px",
                color: "#800001",
              },
              "& .MuiInputLabel-root": {
                color: "#800001",
              },
              "& .MuiInputLabel-shrink": {
                color: "#800001",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#800001", // Default border
                },
                "&:hover fieldset": {
                  borderColor: "#cc0000", // On hover
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#800001", // On focus
                },
              },
            }}
          />
        </Box>
        {filteredData?.map((item) => (
          <Box
            sx={{
              display: "flex",
              border: "2px solid #800001",
              flexDirection: "column",
              p: 1,
              borderRadius: "20px",
              gap: "2px",
            }}
            key={item._id}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontWeight: "bolder", fontSize: "18px" }}>
                  {item.name}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography>{item.mobile}</Typography>
                  <Button component="a" href={`tel:${item.mobile}`}>
                    <CallIcon sx={{ color: "#800001" }} />
                  </Button>
                </Box>
                <Typography sx={{ fontWeight: "bolder" }}>
                  {/* {item.scheme[0].SchemeId?.schemeName} */}
                </Typography>
                <Box sx={{ display: "flex", gap: "20px" }}>
                  <Typography>{item.area.areaName}</Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "Green",
                      textTransform: "capitalize",
                    }}
                  >
                    {item.status}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Button>
                  <DoneIcon sx={{ color: "green" }} />
                </Button>

                {item?.LocationImg?.trim() ? (
                  <Button onClick={() => handleViewCustomer(item._id)}>
                    <VisibilityIcon sx={{ color: "#800001" }} />
                  </Button>
                ) : (
                  <Button onClick={() => handlePhotoUpdate(item._id)}>
                    <AddAPhotoIcon sx={{ color: "#800001" }} />
                  </Button>
                )}
                {item.lat && item.long ? (
                  <Button
                    component="a"
                    target="_blank"
                    onClick={() => handleNavigation(item.lat, item.long)}
                  >
                    <NearMeIcon sx={{ color: "#EEC056" }} />
                  </Button>
                ) : (
                  <Button onClick={() => handlenewLocation(item._id)}>
                    <MyLocationIcon sx={{ color: "#EEC056" }} />
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                borderTop: "1px solid #800001",
                justifyContent: "space-between",
                alignItems: "center",
                pt: 1,
              }}
            >
              <Typography>
                Schemes:{" "}
                {
                  item.scheme.filter((scheme) => scheme.status === "active")
                    .length
                }
              </Typography>
              <Button
                onClick={() => handlePayment(item._id)}
                sx={{
                  backgroundColor: "#800001",
                }}
              >
                <CurrencyRupeeIcon sx={{ color: "#fff" }} />
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
      <AddCustomer
        openCustomer={openAddCust}
        setOpenCustomer={setOpenAddCust}
        editId={editId}
        setEditId={setEditId}
      />
      <Payments
        openPaymentModal={openPaymentModal}
        setOpenPaymentModal={setOpenPaymentModal}
        customerId={customerId}
        setCustomerId={setCustomerId}
      />

      <>
        <Modal
          aria-labelledby="modal-title"
          aria-describedby="modal-desc"
          open={openConfirmLocation}
          onClose={handleCloseConfirmModal}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              maxWidth: 200,
              width: "100%",
              bgcolor: "#FEDDDD",
              p: 2,
              borderRadius: "md",
              boxShadow: "lg",
              m: 2,
            }}
          >
            {/* <ModalClose
              sx={{
                m: 1,
                "& svg": { color: "#800001" },
                "&:hover": {
                  backgroundColor: "#800001",
                  "& svg": { color: "#fff" },
                },
              }}
              onClick={handleCloseConfirmModal}
            /> */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography>Confirm Location?</Typography>
              </Box>
              <Box sx={{ display: "flex", gap: "10px", marginTop: 2 }}>
                <Button
                  sx={{
                    backgroundColor: "#800001",
                    color: "#fff",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": { backgroundColor: "#fbbd2c", color: "#000" },
                  }}
                  onClick={handleCloseConfirmModal}
                >
                  Cancel
                </Button>
                <Button
                  sx={{
                    backgroundColor: "#800001",
                    color: "#fff",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": { backgroundColor: "#fbbd2c", color: "#000" },
                  }}
                  onClick={handleConfirmAssign}
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          </Sheet>
        </Modal>
      </>
      {openCamera && (
        <Modal
          open={openCamera}
          onClose={() => {
            setOpenCamera(false);
            setImageSrc(null);
            setUploading(false);
          }}
        >
          <Sheet
            variant="outlined"
            sx={{
              width: 300,
              bgcolor: "#fff",
              p: 2,
              m: "auto",
              mt: 5,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            {!imageSrc ? (
              <>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width="100%"
                  height="100%"
                  videoConstraints={{
                    facingMode: "environment",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "#800001",
                      color: "#fff",
                      "&:hover": { backgroundColor: "#fbbd2c", color: "#000" },
                    }}
                    onClick={() => {
                      setOpenCamera(false);
                      setImageSrc(null);
                      setUploading(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={uploading}
                    sx={{
                      backgroundColor: "#800001",
                      color: "#fff",
                      fontWeight: "bold",
                      "&:hover": { backgroundColor: "#fbbd2c", color: "#000" },
                    }}
                    onClick={() => {
                      const image = webcamRef.current.getScreenshot();
                      if (image) setImageSrc(image);
                    }}
                  >
                    Capture Photo
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <img
                  src={imageSrc}
                  alt="Captured"
                  style={{ width: "100%", borderRadius: 8 }}
                />
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    disabled={uploading}
                    sx={{
                      backgroundColor: "#800001",
                      color: "#fff",
                      fontWeight: "bold",
                      "&:hover": { backgroundColor: "#fbbd2c", color: "#000" },
                    }}
                    onClick={uploadCapturedPhoto}
                  >
                    {uploading ? "Uploading..." : "Upload"}
                  </Button>
                  <Button
                    disabled={uploading}
                    sx={{
                      backgroundColor: "#ccc",
                      color: "#000",
                    }}
                    onClick={() => setImageSrc(null)}
                  >
                    Retake
                  </Button>
                </Box>
              </>
            )}
          </Sheet>
        </Modal>
      )}
      <ViewMobCustDetails
        handleCloseViewCustomer={handleCloseViewCustomer}
        openViewCustomer={openViewCustomer}
        customerId={customerId}
        setCustomerId={setCustomerId}
      />
    </>
  );
};

export default PaymentList;
